import Nav from "./Nav";

const Header = () => (
  <header className="relative flex flex-col justify-between bg-secondary text-white h-[50rem]">
    <div className="absolute inset-0">
      <img
        src="/images/hero-bg2.jpeg"
        alt="Background"
        className="w-full h-full object-cover"
      />
      <div
        className="absolute inset-0"
        style={{ backgroundColor: "rgba(24, 38, 66, 0.90)" }}
      />
    </div>
    <Nav></Nav>
  </header>
);

export default Header;
